import { Button, Collapse } from 'reactstrap';
import { DATE, formatDateNonUTC, getDiff } from '../../../utils/date';
import { AgentThinking } from '../types';
import { DataContainer } from './DataContainer';
import { Gutter } from './Gutter';
import { useState } from 'react';

export const AgentThinkingContainer = ({ data, isThinking, endTimestamp }: { data: AgentThinking, isThinking: boolean, endTimestamp?: string }) => {
  const { timestamp, message } = data;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className='d-flex w-100'>
      <Gutter />
      <div className='text-right overflow-hidden flex-grow-1' style={{ minWidth: '50%' }}>
        <div className='text-right text-ThemeAccentDark justify-content-between mb-1'>
          <small>{formatDateNonUTC(timestamp, DATE.HUMANIZE)}{endTimestamp ? ` for ${getDiff(endTimestamp, timestamp, 'second')} seconds` : ''}</small>
        </div>
        <div className='message-content mb-0 text-ThemeAccentDark'>
          {isThinking ? <i className='fas fa-spinner fa-spin me-2' /> : null }
          {message}
        </div>
        {data.data ? (
          <>
          <Button color='link' onClick={() => setIsOpen(!isOpen)}><i className='fas fa-chevron-down' /> toggle</Button>
          <Collapse isOpen={isOpen}>
            <DataContainer data={data.data} />
          </Collapse>
          </>
        ) : null}
      </div>
      <Gutter icon={true} right={true}>
        {isThinking ? <i className='fas fa-spinner fa-spin fa-lg' /> : <i className='fas fa-check text-secondary fa-lg' />}
      </Gutter>
    </div>
  );
};
